import React from 'react'
import Header from '../component/Header'
import Donate from '../component/Donate'
import BottomBar from '../component/BottomBar'
import { FaAngleRight, FaHeart } from 'react-icons/fa6'
import { Helmet } from 'react-helmet-async'

function DonateMon() {

    const donationClick =()=>{
        const menu_dropdown = document.querySelector(".donate_header")
        menu_dropdown.classList.toggle("donate_dropDown");
    }

  return (
    <>
        <Helmet>
            <title>Donate Monthly | The Lord Nations Foundation</title>
            <meta name="description" content="Make a lasting impact by donating monthly to The Lord Nations Foundation. Your support helps us continue our mission to change lives." />
        </Helmet>

        <div className='home' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='donateMobanner' >
                <div className='homebanner_overlay'>
                    <div className='homebanner_container'>
                        <div className='homebanner_text' >
                            <div className='donatenow_banner_label' >
                                <h3>DONATE MONTHLY</h3>
                            </div>
                        </div>

                        <div className='danate_desk'>
                            <Donate/>
                        </div>
                    </div>
                </div>
            </div>


            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h2>BECOME A MONTHLY DONOR TODAY</h2>
                </div>

                <p>
                    Become a Monthly Donor Today and help provide children with the education they deserve. Your support ensures access to quality learning, school supplies, and a brighter future for every child in need. Together, we can make a lasting impact—one school day at a time.
                </p>

                <div className='about_sub_header'>
                    <h2>
                        YOUR <span style={{color:'#da291c'}}> $25 MONTHLY GIFT </span> COULD HELP CHILDREN WITH GOOD EDUCATION AROUND THE WORLD.
                    </h2>

                    <div onClick={()=>donationClick()} className='monthly_donate_btn'>
                        <FaHeart className='desk_header_donate_btn_icon' />
                        <h2>Start your monthly gift today</h2>
                    </div>
                </div>
            </div>

            <div className='danate_mob'>
            <Donate/>
            </div>

            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h2>HOW YOUR MONTHLY DONATION MAKES A DIFFERENCE</h2>
                </div>

                <div className='about_sub_header'>
                    
                    <h3 style={{margin: '15px 0'}} >
                        Our <span style={{color:'#da291c'}}> regular givers </span> are a crucial part of our work. By <span style={{color:'#da291c'}}> giving monthly </span>, you can help us to:
                    </h3>

                    <h3>1. Be ready when an emergency hits</h3>
                    <p style={{fontSize:'16px', lineHeight:'24px', color:'#4b4b4b'}}>
                        When a disaster strikes it's always children that suffer the most. Our Emergency Fund is designed to ensure we are ready to react quickly, and effectively when children are at risk.
                    </p>

                    <h3>2. Develop long-term solutions</h3>
                    <p style={{fontSize:'16px', lineHeight:'24px', color:'#4b4b4b'}}>
                        Having guaranteed income from our generous monthly givers means we are able to plan for long term solutions and invest in bigger projects. This means we are able to look not only at reactive work to support children - for example after natural disasters - but also develop sustainable and ongoing support for children.
                    </p>
                    
                    <h3>3. Make donating easier for you</h3>
                    <p style={{fontSize:'16px', lineHeight:'24px', color:'#4b4b4b'}}>
                        Many of our monthly givers feel it is easier to set up a regular gift as this way they are able to give proportionately more than they might for just a single donation, but can spread the cost across the year. Our monthly donations are flexible and easy to manage.
                    </p>

                </div>
            </div>

            
                    <div className='about_sub' >
                        <div className='about_sub_header'>
                            <div className='about_sub_header_line'></div>
                            <h2>For every $1 you donate we spend</h2>
                        </div>
            
                        <div className='about_sub_body'>
                            <div className='about_sub_body_img2'></div>
            
                                <div className='about_sub_body_writeup'>
            
                                    <div className='about_sub_body_writeup_body donate_now_write_ups'>
                                        <p>The Lord Nations Foundation stands side by side with children in the world's toughest places. Your donations make this support possible.</p>
                                        <div onClick={()=>donationClick()} className='donate_now_write_ups_btn'>
                                            <p>DONATE NOW</p>
                                            <FaAngleRight/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>

            <BottomBar/>
        </div>
    </>
  )
}

export default DonateMon